import React, { useEffect, useState } from "react";
import { API_URL } from "../config";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { showToast } from "../components/toast";
import { hasPermission, getRoleDetails, getRoleUserid } from "../helpers/permission.js";

const AddPaidServiceOrderPopup = ({
  onClose,
  dropdownOptions,
  fetchSubscriptions,
}) => {
  const token = localStorage.getItem("authToken");
  const [loading, setLoading] = useState(false);
  const [orderList, setOrderList] = useState([]);
  const [subscriberList, setSubscriberList] = useState([]);
  const [paidServiceData, setPaidServiceData] = useState({
    subscriberid: "",
    orderid: "",
    serviceid: "",
    trade_purchase: "",
    amount: "",
    activation_date: "",
    referralcode: "",
  });

  useEffect(() => {
    // Set default activation date to today + 1 day
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    setPaidServiceData((prev) => ({ ...prev, activation_date: tomorrow }));
  }, []);

  const fetchSubscribers = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${API_URL}subscriber`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.success) {
        setSubscriberList(response.data.data.subscribers || []);
      }
    } catch (error) {
      console.error("Error fetching dropdown options:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_URL}orders/unmapped-orders/${paidServiceData.subscriberid}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.success) {
        setOrderList(response.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching dropdown options:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (paidServiceData.subscriberid) {
      fetchOrders();
    }
  }, [paidServiceData.subscriberid]);

  useEffect(() => {
    fetchSubscribers();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "orderid") {
      const selectedOrder = orderList.find(
        (order) => order.id === parseInt(value)
      );
      setPaidServiceData((prev) => ({
        ...prev,
        [name]: value,
        amount: selectedOrder?.amount_payable || "",
      }));
    } else {
      setPaidServiceData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleDateChange = (name, date) => {
    setPaidServiceData((prev) => ({ ...prev, [name]: date }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!paidServiceData.subscriberid) {
      showToast.warning("please select subscriber");
      return;
    }

    if (!paidServiceData.orderid) {
      showToast.warning("please select order");
      return;
    }

    if (!paidServiceData.serviceid) {
      showToast.warning("please select service");
      return;
    }

    if (!paidServiceData.trade_purchase) {
      showToast.warning("please select trades purchase");
      return;
    }

    if (!paidServiceData.amount) {
      showToast.warning("amount is required");
      return;
    }

    if (!paidServiceData.activation_date) {
      showToast.warning("please select activation date");
      return;
    }

    try {
      const payload = {
        subscriberId: parseInt(paidServiceData.subscriberid),
        serviceId: parseInt(paidServiceData.serviceid),
        trades_total: parseInt(paidServiceData.trade_purchase),
        orderId: parseInt(paidServiceData.orderid),
        amount: parseInt(paidServiceData.amount),
        activation_date: paidServiceData.activation_date,
        stype: "Paid",
        status: "In Progress",
        expiry_date: "",
        referralcode: paidServiceData.referralcode || null,
      };

      const response = await axios.post(
        `${API_URL}subscription/save-paid-popup`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      //  Acttual API URL should be used here 221
      if (response.data.success === true) {
        showToast.success(
          showToast.success("Paid Service Order Added Successfully")
        );
        setTimeout(() => onClose(), 2000); // Close the modal after 2 seconds
        fetchSubscriptions();
      } else {
        showToast.error(response.data.message || "Failed to add Service");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      showToast.error("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }

    setPaidServiceData({
      subscriberid: "",
      orderid: "",
      serviceid: "",
      trade_purchase: "",
      amount: "",
      activation_date: "",
      referralcode: "",
    });
    onClose();
  };

  const isDistributorVisible = () => {
    return hasPermission("subscription_distributor", "view");
  };

  const isDistributorEditable = () => {
    return hasPermission("subscription_distributor", "edit");
  };

  return (
    <div
      className="modal fade show"
      style={{ display: "block" }}
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog" style={{ maxWidth: "30rem" }}>
        <div className="modal-content">
          <div id="myModalContent">
            <div className="modal-header">
              <div className="col-md-11">
                <h5 className="modal-title" style={{ fontWeight: "bold" }}>
                  Add Paid Service For Order
                </h5>
              </div>
              <button
                type="button"
                className="btn btn-default"
                onClick={onClose}
              >
                &times;
              </button>
              <div className="clearfix"></div>
            </div>

            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="panel-body">
                  <div className="row">
                    <table className="table table-condensed table-hover bg-white usertable">
                      <tbody>
                        <tr>
                          <td>
                            Subscriber <span style={{ color: "red" }}>*</span>
                          </td>
                          <td>
                            <select
                              name="subscriberid"
                              className="form-control"
                              onChange={handleChange}
                            >
                              <option>Select Subcriber</option>
                              {subscriberList.map((option, index) => (
                                <option key={index} value={option.id}>
                                  {`${option.user_full_name} (${option.subscriberid}) (${option.mobileno})`}
                                </option>
                              ))}
                            </select>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Orders <span style={{ color: "red" }}>*</span>
                          </td>
                          <td>
                            <select
                              name="orderid"
                              value={paidServiceData.orderid}
                              className="form-control"
                              onChange={handleChange}
                              required
                            >
                              <option>Select order</option>
                              {orderList.map((option, index) => (
                                <option key={index} value={option.id}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Service <span style={{ color: "red" }}>*</span>
                          </td>
                          <td>
                            <select
                              name="serviceid"
                              className="form-control"
                              value={paidServiceData.serviceid}
                              onChange={handleChange}
                              required
                            >
                              <option value="" selected>
                                - Select -
                              </option>
                              {dropdownOptions?.serviceList?.map(
                                (option, index) => (
                                  <option key={index} value={option.id}>
                                    {option.service_name}
                                  </option>
                                )
                              )}
                            </select>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            Trades Purchase{" "}
                            <span style={{ color: "red" }}>*</span>
                          </td>
                          <td>
                            <select
                              name="trade_purchase"
                              className="form-control"
                              value={paidServiceData.trade_purchase}
                              onChange={handleChange}
                              required
                            >
                              <option value="" selected>
                                - Select -
                              </option>
                              {dropdownOptions?.paidTradesList?.map(
                                (option, index) => (
                                  <option key={index} value={option.pick_name}>
                                    {option.pick_name}
                                  </option>
                                )
                              )}
                            </select>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            Amount <span style={{ color: "red" }}>*</span>
                          </td>
                          <td>
                            <input
                              type="text"
                              name="amount"
                              value={paidServiceData.amount}
                              onChange={handleChange}
                              placeholder="Enter Amount"
                              className="form-control"
                              required
                              disabled
                            />
                          </td>
                        </tr>

                        <tr>
                          <td>
                            Activation Date{" "}
                            <span style={{ color: "red" }}>*</span>
                          </td>
                          <td>
                            <DatePicker
                              selected={paidServiceData.activation_date}
                              onChange={(date) =>
                                handleDateChange("activation_date", date)
                              }
                              dateFormat="dd-MM-yyyy"
                              className="form-control"
                              placeholderText="Select Activation Date"
                            />
                          </td>
                        </tr>

                        {isDistributorVisible() && (
                          <tr>
                            <td>Distributor / Referral Code</td>
                            <td>
                              <select
                                name="referralcode"
                                className="form-control"
                                value={paidServiceData.referralcode}
                                onChange={handleChange}
                                disabled={!isDistributorEditable()}
                              >
                                <option value="">- Select Distributor -</option>
                                {dropdownOptions?.distributorList?.map(
                                  (item, index) => (
                                    <option
                                      key={index}
                                      value={item.referralcode || ""}
                                    >
                                      {item.user_fullname}{" "}
                                      {item.referralcode
                                        ? `(${item.referralcode})`
                                        : ""}
                                    </option>
                                  )
                                )}
                              </select>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    <div
                      className="col-md-12 mt-3"
                      style={{ textAlign: "right" }}
                    >
                      <button
                        type="submit"
                        name="submit"
                        className="btn btn-primary me-2"
                      >
                        Submit
                      </button>
                      <button
                        type="button"
                        name="cancel"
                        className="btn btn-default"
                        onClick={onClose}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPaidServiceOrderPopup;
